var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"marketplace-bg"}),_c('MarketplaceHero'),_c('Marketplace'),_c('img',{staticClass:"marketplace-clover",attrs:{"src":require("@/assets/images/marketplace/clover.png")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }